import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 20,
  },
  sectionTitle: {
    fontWeight: '700',
    marginBottom: 4,
    color: '#1C1C1E',
  },
  subLabel: {
    marginBottom: 12,
    lineHeight: 20,
  },
  subLabelText: {
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 20,
  },

  textArea: {
    minHeight: 140,
    maxHeight: 200,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 8,
    padding: 12,
    paddingBottom: 14,
    fontSize: 12,
    color: '#1E1E1E',
    backgroundColor: '#FFF',
    textAlignVertical: 'top',
    lineHeight: 20,
  },
  textAreaError: {
    borderColor: '#B04B3A',
  },
  charCount: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'left',
    marginTop: 8,
  },
  charCountError: {
    color: '#900B09',
  },
  errorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginTop: 4,
  },
  errorText: {
    fontSize: 12,
    color: '#900B09',
    fontWeight: '400',
  },
  errorIcon: {
    color: '#B91C1C',
    fontSize: 16,
  },
  textAreaWarning: {
    borderColor: '#522504',
  },
  charCountWarning: {
    color: '#522504',
  },
  warningIcon: {
    color: '#522504',
    fontSize: 16,
  },
  warningText: {
    fontSize: 12,
    color: '#522504',
  },
  charCountContainer: {
    marginVertical: 5,
  },
});
